import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Jul 08 2019
 * @author LZe
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ReleaseItemPromos } from '@logio/common-be-fe';
import { computed, observable, runInAction } from 'mobx';
import * as React from 'react';
import { LoadingState } from '../../../../../shared/api/LoadingState';
import { getDateFormat } from '../../../../../shared/date/getDateFormat';
import translate from '../../../../i18n/translate';
import Alert, { AlertType } from '../../../../info/Alert';
import Loader from '../../../../info/Loader';
import CellTooltip from './CellTooltip';
import { CONSTANTS } from "../../../../../constants";

var AbstractPromoTooltip =
/*#__PURE__*/
function (_CellTooltip) {
  _inherits(AbstractPromoTooltip, _CellTooltip);

  function AbstractPromoTooltip() {
    var _this;

    _classCallCheck(this, AbstractPromoTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractPromoTooltip).apply(this, arguments));
    /** Current Row */

    _this.row = _this.props.api.getDisplayedRowAtIndex(_this.props.rowIndex);
    return _this;
  }

  _createClass(AbstractPromoTooltip, [{
    key: "load",
    value: function load() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!this.row) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return this.getPromos();

              case 4:
                data = _context.sent;
                runInAction(function () {
                  _this2.data = data;
                  _this2.loadingState = LoadingState.Success;
                });

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                runInAction(function () {
                  return _this2.loadingState = LoadingState.Error;
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));
    }
  }, {
    key: "getPromoPriceStatsData",
    value: function getPromoPriceStatsData() {
      var promoPriceStats = {
        zoneId: this.props.column.colId.split('_')[1],
        minAmount: CONSTANTS.FORMAT.NULL,
        lastAmount: CONSTANTS.FORMAT.NULL,
        averageAmount: CONSTANTS.FORMAT.NULL
      };
      var promoPrices = this.row.data["ReleaseDetailCategory_".concat(promoPriceStats.zoneId, "_promoPriceStats")];

      if (promoPrices) {
        promoPriceStats.minAmount = promoPrices.minAmount ? promoPrices.minAmount.toString() : CONSTANTS.FORMAT.NULL;
        promoPriceStats.lastAmount = promoPrices.lastAmount ? promoPrices.lastAmount.toString() : CONSTANTS.FORMAT.NULL;
        promoPriceStats.averageAmount = promoPrices.averageAmount ? promoPrices.averageAmount.round(1).toString() : CONSTANTS.FORMAT.NULL;
      } else if (this.row.data.promoPriceStats) {
        var _JSON$parse = JSON.parse(this.row.data.promoPriceStats),
            lastAmount = _JSON$parse.lastAmount,
            minAmount = _JSON$parse.minAmount,
            averageAmount = _JSON$parse.averageAmount;

        promoPriceStats.minAmount = minAmount && minAmount.value ? minAmount.value.toString() : CONSTANTS.FORMAT.NULL;
        promoPriceStats.lastAmount = lastAmount && lastAmount.value ? lastAmount.value.toString() : CONSTANTS.FORMAT.NULL;
        promoPriceStats.averageAmount = averageAmount && averageAmount.value ? averageAmount.value.toString() : CONSTANTS.FORMAT.NULL;
      }

      return promoPriceStats;
    }
  }, {
    key: "renderPromotions",
    value: function renderPromotions() {
      var _this3 = this;

      if (this.loadingState === LoadingState.Pending) {
        return React.createElement(Loader, null);
      }

      if (this.data != null && this.data.promotions != null && this.data.promotions.size > 0) {
        return React.createElement("table", {
          className: "table"
        }, React.createElement("tr", null, React.createElement("th", null, translate('Promotion_name')), React.createElement("th", null, translate('Promotion_dateFrom')), React.createElement("th", null, translate('Promotion_dateTo'))), React.createElement("tbody", null, this.data.promotions.map(function (promo) {
          return React.createElement("tr", {
            key: "".concat(_this3.row.id, "_").concat(promo.id)
          }, React.createElement("td", null, promo.name), React.createElement("td", null, promo.dateFrom.format(getDateFormat())), React.createElement("td", null, promo.dateTo.format(getDateFormat())));
        })));
      }

      return React.createElement(Alert, {
        type: AlertType.Info
      }, translate('message_no_promotions_found'));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.renderPromotions(), this.promoPriceStatsTable);
    }
  }, {
    key: "promoPriceStatsTable",
    get: function get() {
      var _this$getPromoPriceSt = this.getPromoPriceStatsData(),
          minAmount = _this$getPromoPriceSt.minAmount,
          lastAmount = _this$getPromoPriceSt.lastAmount,
          averageAmount = _this$getPromoPriceSt.averageAmount,
          zoneId = _this$getPromoPriceSt.zoneId;

      return React.createElement("table", {
        className: "table table-stripedX w-100"
      }, React.createElement("tbody", null, React.createElement("tr", {
        key: zoneId
      }, React.createElement("th", null, translate("PriceZoneReleasePrices_promoPriceStats_lastAmount")), React.createElement("td", null, React.createElement("span", {
        className: "tal fr"
      }, lastAmount))), React.createElement("tr", null, React.createElement("th", null, translate("PriceZoneReleasePrices_promoPriceStats_averageAmount")), React.createElement("td", null, React.createElement("span", {
        className: "tal fr"
      }, averageAmount))), React.createElement("tr", null, React.createElement("th", null, translate("PriceZoneReleasePrices_promoPriceStats_minAmount")), React.createElement("td", null, React.createElement("span", {
        className: "tal fr"
      }, minAmount)))));
    }
  }]);

  return AbstractPromoTooltip;
}(CellTooltip);

export { AbstractPromoTooltip as default };

__decorate([observable, __metadata("design:type", ReleaseItemPromos)], AbstractPromoTooltip.prototype, "data", void 0);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], AbstractPromoTooltip.prototype, "promoPriceStatsTable", null);